export const environment = {
  production: false,
  staging: false,

  apiLogin: 'https://dev.asgcare.dk/api/login',
  apiResetPassword: 'https://dev.asgcare.dk/api/reset-password',

  apiLogOut: 'https://dev.asgcare.dk/api/authentication/logout',

  apiGetUsers: 'https://dev.asgcare.dk/api/users/getAll',
  apiGetUserByID: 'https://dev.asgcare.dk/api/users/get/',
  apiCreateUser: 'https://dev.asgcare.dk/api/users/create',
  apiUpdateUser: 'https://dev.asgcare.dk/api/users/update',
  apiDeleteUser: 'https://dev.asgcare.dk/api/users/delete/',
  apiRestoreUser: 'https://dev.asgcare.dk/api/users/restore/',

  apiGetCompanyInfoFromCVR: 'https://dev.asgcare.dk/api/cvr/company/',
  apiGetCompanyWithSubsidiaryFromCVR:
    'https://dev.asgcare.dk/api/cvr/companyWithSubsidiary/',

  apiGetCPRLogs: 'https://dev.asgcare.dk/api/cpr/log',
  apiGetInfoFromCPR: 'https://dev.asgcare.dk/api/cpr/get',

  apiApplyForSJFInsurance: 'https://dev.asgcare.dk/api/forsia/apply',
  apiApplyForHelvetiaInsurance:
    'https://dev.asgcare.dk/api/application/helvetia',
  apiApplyForHelvetiaInsuranceNoAuth:
    'https://dev.asgcare.dk/api/helvetia/apply',
  apiApplyForHelvetiafleetPolicie:
    'https://dev.asgcare.dk/api/helvetia/riskItem/add',
  apiHelvetiaPrice: 'https://dev.asgcare.dk/api/helvetia/price',

  apiImpersonate: 'https://dev.asgcare.dk/api/impersonate/',

  apiGetSettings: 'https://dev.asgcare.dk/api/settings/get',
  apiUpdateSettings: 'https://dev.asgcare.dk/api/settings/update',
  apiGetFragusCommissions: 'https://dev.asgcare.dk/api/powertrain/fragus-commission/get',
  apiUpdateFragusCommissions: 'https://dev.asgcare.dk/api/powertrain/fragus-commission/update',

  apiGetDealers: 'https://dev.asgcare.dk/api/dealers/getAll',
  apiGetDealerByID: 'https://dev.asgcare.dk/api/dealers/get/',
  apiDeleteDealerByID: 'https://dev.asgcare.dk/api/dealers/delete/',
  apiUpdateDealer: 'https://dev.asgcare.dk/api/dealers/update',
  apiCreateDealer: 'https://dev.asgcare.dk/api/dealers/create',
  apiRestoreDealer: 'https://dev.asgcare.dk/api/dealers/restore/',

  apiGetInsurancePrices: 'https://dev.asgcare.dk/api/insurance-info/get/prices',

  apiGetVehicleFromDMRByVIN: 'https://dev.asgcare.dk/api/vehicle-info/vin/',
  apiGetVehicleFromDMRByReg: 'https://dev.asgcare.dk/api/vehicle-info/reg/',

  apiScrapeVehicleFromDMRByVIN: 'https://dev.asgcare.dk/api/vehicle-info/vin/live/',
  apiScrapeVehicleFromDMRByReg: 'https://dev.asgcare.dk/api/vehicle-info/reg/live/',

  apiGetSubsidiaries: 'https://dev.asgcare.dk/api/subsidiaries/getAll',
  apiGetSubsidiaryById: 'https://dev.asgcare.dk/api/subsidiaries/get/',
  apiUpdateSubsidiary: 'https://dev.asgcare.dk/api/subsidiaries/update',

  apiGetLeads: 'https://dev.asgcare.dk/api/leads/getAll',
  apiGetSortedLeads: 'https://dev.asgcare.dk/api/leads/get',
  apiUpdateLead: 'https://dev.asgcare.dk/api/lead-status/update',

  apiGetPriceTag: 'https://dev.asgcare.dk/api/price-tag',

  apiGetKsfTemplate: 'https://dev.asgcare.dk/api/kf/template',
  apiGetInitialKsfPrice: 'https://dev.asgcare.dk/api/kf/price',
  apiUpdateKsfTemplate: 'https://dev.asgcare.dk/api/kf/template',
  apiApplyForKsf: 'https://dev.asgcare.dk/api/kf/confirm',

  apiApplyForPowerTrain: 'https://dev.asgcare.dk/api/powertrain/apply',
  apiGetPricePowerTrain: 'https://dev.asgcare.dk/api/powertrain/price',
  apiGetAddonsPowerTrain: 'https://dev.asgcare.dk/api/powertrain/addons',
  apiGetPowerTrainLead: 'https://dev.asgcare.dk/api/powertrain/get',

  apiGetCommissionById: 'https://dev.asgcare.dk/api/commission/',

  apiGetForsiaForwardedLeads:
    'https://dev.asgcare.dk/api/forsia/leads/internal/',
  apiGetForsiaPrices: 'https://dev.asgcare.dk/api/forsia/price',
  apiGetForsiaExcessPrices:
    'https://dev.asgcare.dk/api/forsia/referenceTable/excess',
  apiGetForsiaEquipmentTable:
    'https://dev.asgcare.dk/api/forsia/referenceTable/equipment',
  apiGetForsiaMileageTable:
    'https://dev.asgcare.dk/api/forsia/referenceTable/mileage',
  apiForwardLead: 'https://dev.asgcare.dk/api/forsia/insurance-lead',
  apiRefreshToken: 'https://dev.asgcare.dk/api/refresh-token',
};
